module.exports = __webpack_public_path__ + "img/rubin_benefit_09_glasses.0d1181c2.svg";